import { memo } from "react";
import { LuAlarmClock } from "react-icons/lu";

const TrucoDigitalTimer = memo(({ remaining = 0, x = 0, y = 0 }) => {
    return (
        <div
            className="truco-digital-timer-main"
            style={{ transform: `translate(${x}px, ${y}px)` }}
        >
            <div className="truco-digital-timer">
                {/* <LuAlarmClock /> */}
                <div className="truco-digital-time">{remaining || 25}</div>
            </div>
        </div >
    )
})

export default TrucoDigitalTimer